module.exports = __webpack_public_path__ + "img/emptyBlack.9390fe9d.png";